import { CompanyRepository, ProductsRepository } from "lib/index";
import { createResourceInstance } from "modules/utils/index";

export const SET_CURRENT_USER = "auth/SET_CURRENT_USER";
export const CHANGE_CURRENT_COMPANY = "auth/CHANGE_CURRENT_COMPANY";
export const FETCH_CURRENT_USER = "auth/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "auth/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "auth/FETCH_CURRENT_USER_FAILURE";
export const FETCH_CURRENT_COMPANY = "auth/FETCH_CURRENT_COMPANY";
export const FETCH_CURRENT_COMPANY_START = "auth/FETCH_CURRENT_COMPANY_START";
export const FETCH_CURRENT_COMPANY_SUCCESS = "auth/FETCH_CURRENT_COMPANY_SUCCESS";
export const FETCH_CURRENT_COMPANY_FAILURE = "auth/FETCH_CURRENT_COMPANY_FAILURE";
export const FETCH_PRODUCTS = "auth/FETCH_PRODUCTS";
export const FETCH_PRODUCTS_START = "auth/FETCH_PRODUCTS_START";
export const FETCH_PRODUCTS_SUCCESS = "auth/FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "auth/FETCH_PRODUCTS_FAILURE";
export const LOGOUT = "auth/LOGOUT";

export const stateSelector = (state) => state.auth;

export const companyInstance = createResourceInstance({
  FETCH: FETCH_CURRENT_COMPANY,
  FETCH_START: FETCH_CURRENT_COMPANY_START,
  FETCH_SUCCESS: FETCH_CURRENT_COMPANY_SUCCESS,
  FETCH_FAILURE: FETCH_CURRENT_COMPANY_FAILURE,
  stateSelector,
  stateKey: "company",
  withSuccessAlert: false,
  withFailureAlert: false,
  getModel: () => {
    return CompanyRepository.show();
  },
});

export const productsInstance = createResourceInstance({
  FETCH: FETCH_PRODUCTS,
  FETCH_START: FETCH_PRODUCTS_START,
  FETCH_SUCCESS: FETCH_PRODUCTS_SUCCESS,
  FETCH_FAILURE: FETCH_PRODUCTS_FAILURE,
  stateSelector,
  stateKey: "products",
  withSuccessAlert: false,
  withFailureAlert: false,
  getModel: () => {
    return ProductsRepository.search();
  },
});

export const { load: loadProducts, fetch: fetchProducts } = productsInstance.actions;
export const { load: loadCurrentCompany, fetch: fetchCurrentCompany } = companyInstance.actions;

export function fetchCurrentUser() {
  return { type: FETCH_CURRENT_USER };
}

export function setCurrentUser({ user = null, auth_token = null } = {}) {
  return { type: SET_CURRENT_USER, user, auth_token };
}

export function changeCurrentCompany(companyId) {
  return { type: CHANGE_CURRENT_COMPANY, companyId };
}

// revokeToken: also invalidate the token on the server (explicit user logout,
// not a reaction to a 401 where the token is already dead)
export function logout({ revokeToken = false } = {}) {
  return { type: LOGOUT, revokeToken };
}



// WEBPACK FOOTER //
// ./src/modules/auth/actions.js